export var DEPLOY_DATE = new Date('2026-07-23T14:36:56+0000');
